import { TabsRootDataAttributes } from "./TabsRootDataAttributes.js";
export const tabsStyleHookMapping = {
  tabActivationDirection: dir => ({
    [TabsRootDataAttributes.activationDirection]: dir
  })
};